import Icon from '../components/Icon.vue'

Icon.register({
  'mortar-pestle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M501.5 60.9l-99.1 99.1h-151.4l203.8-152.9c5.3-3.9 14.8-7.1 21.4-7.1 4.6 0 11.8 1.7 16 3.8 21.8 10.9 26.5 39.9 9.3 57.1zM496 192c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-16c0 81-50.2 150.1-121.1 178.3 12.8 16.9 21.7 36.8 25 58.7 1.5 9.9-6 19-16.1 19h-223.5c-10 0-17.5-9.1-16.1-19 3.2-21.9 12.2-41.8 25-58.7-70.9-28.2-121.1-97.3-121.1-178.3h-16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h480z'
      }
    ]
  }
})
